import React, { FC, useContext, useEffect, useRef, useState } from 'react';
import styles from './CategoriesSlider.module.scss';
import { useTranslation } from 'react-i18next';
import { Navigation } from 'swiper';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import leftArrow from '../../../../assets/img/arrowLeftOutlined.svg';
import rightArrow from '../../../../assets/img/arrowRightOutlined.svg';

import 'swiper/css';
import { CategoriesModel } from '../../../../pages/home/query/types';
import { generateImageUrl } from '../../../../utils/cdnService';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../../context/auth';
import { useLoginRedirection } from '../../../../context/auth/utils';
type Props = {
  categories: CategoriesModel[];
};

const CategoriesSlider: FC<Props> = ({ categories }) => {
  const {
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();
  const [width, setWidth] = useState(0);
  const authContext = useContext(AuthContext);
  const { isAuthenticated } = authContext;
  const handleLoginRedirection = useLoginRedirection();

  const ref = useRef<SwiperRef | null>(null);

  const updateWidth = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', updateWidth);

    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  const handleNext = () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      ref.current.swiper?.slideNext();
    }
  };

  const handlePrev = () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      ref.current.swiper?.slidePrev();
    }
  };

  const params = {
    loop: true,
    allowTouchMove: true,
    preventClicks: false,
    preventClicksPropagation: false,
    navigation: {
      nextEl: `${styles.nextButton}`,
      prevEl: `${styles.prevButton}`,
    },
    breakpoints: {
      100: {
        slidesPerView: 2,
      },
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
      1400: {
        slidesPerView: 6,
      },
    },
  };

  const handleClick = (id: number | null) => {
    if(!isAuthenticated) {
      navigate(`/${language}/movies?page=1`)
      return;
    }
    if (id) {
      navigate(`${language}/tag/${id}`);
    }
  };

  return (
    <div className={`${styles.mainSlider} `}>
      <Swiper id="main" ref={ref} className={styles.mainSlider} modules={[Navigation]} {...params}>
        {categories &&
          categories.map((category) => {
            return (
              <SwiperSlide key={category.id}>
                <div className={styles.categoryWrapper} onClick={() => handleClick(category.id)}>
                  <img src={generateImageUrl('gcore', 0, 0, category.image)} alt="" />
                  <div className={styles.categoryName}>
                    <h5>{category.name}</h5>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
      </Swiper>
      <div onClick={handleNext} className={styles.nextButton}>
        <img src={rightArrow} alt="" />
      </div>
      <div onClick={handlePrev} className={styles.prevButton}>
        <img src={leftArrow} alt="" />
      </div>
    </div>
  );
};

export default CategoriesSlider;
